module.exports = __webpack_public_path__ + "static/media/login-icon.1989d2c2.svg";